import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Artikl, ApiClientService } from '../../services/api-client.service';
import { CacheService } from '../../services/cache.service';

@Component({
  selector: 'app-artikli',
  templateUrl: './artikli.component.html',
  styleUrls: ['./artikli.component.scss']
})
export class ArtikliComponent {
  @ViewChild('artikliGrid', { static: false }) artikliGrid: any;

  gridData: Artikl[] = [];
  loading = false;
  isEditPopupVisible = false;
  isCreatePopupVisible = false;
  selectedArtikl: Artikl | null = null;
  loadPanelPosition = { of: '#artikliGrid' };

  artiklForm!: FormGroup;

  constructor(
    private apiClient: ApiClientService,
    private cache: CacheService,
    private fb: FormBuilder
  ) {
    this.initializeForm();
  }

  ngOnInit() {
    this.loadArtikli();
  }

  initializeForm() {
    this.artiklForm = this.fb.group({
      artikl1: ['', Validators.required],
      id: [this.selectedArtikl?.id || null],
      // Add other fields as needed based on your Artikl model
    });
  }

  async loadArtikli() {
    this.loading = true;
    try {
      this.gridData = await this.apiClient.artikliAll();
    } catch (error) {
      console.error('Error loading artikli:', error);
    } finally {
      this.loading = false;
    }
  }

  onRowClick(e: any) {
    if (e.data) {
      this.selectedArtikl = e.data;
    }
  }

  onAddClick() {
    this.selectedArtikl = null;
    this.artiklForm.reset();
    this.isCreatePopupVisible = true;
  }

  onEditClick() {
    if (this.selectedArtikl) {
      this.populateForm(this.selectedArtikl);
      this.isEditPopupVisible = true;
    }
  }

  // onDeleteClick() {
  //   if (this.selectedArtikl && confirm('Are you sure you want to delete this artikl?')) {
  //     this.deleteArtikl(this.selectedArtikl.id as number);
  //   }
  // }

  populateForm(artikl: Artikl) {
    this.artiklForm.patchValue({
      artikl1: artikl.artikl1,
      id: artikl.id,
    });
  }

  async createArtikl() {
    if (this.artiklForm.valid) {
      this.loading = true;
      try {
        const formData = this.artiklForm.value;
        formData.id = 0; // Ensure ID is zero for creation
        await this.apiClient.artikliPOST(formData);
        this.isCreatePopupVisible = false;
        this.artiklForm.reset();
        this.loadArtikli(); // Refresh grid
      } catch (error) {
        console.error('Error creating artikl:', error);
      } finally {
        this.loading = false;
      }
    }
  }

  async updateArtikl() {
    if (this.artiklForm.valid && this.selectedArtikl) {
      this.loading = true;
      try {
        const formData = this.artiklForm.value;
        await this.apiClient.artikliPUT(this.selectedArtikl.id as number, formData);
        this.isEditPopupVisible = false;
        this.loadArtikli(); // Refresh grid
      } catch (error) {
        console.error('Error updating artikl:', error);
      } finally {
        this.loading = false;
      }
    }
  }

  // async deleteArtikl(id: number) {
  //   this.loading = true;
  //   try {
  //     await this.apiClient.artikliDELETE(id);
  //     this.selectedArtikl = null;
  //     this.loadArtikli(); // Refresh grid
  //   } catch (error) {
  //     console.error('Error deleting artikl:', error);
  //   } finally {
  //     this.loading = false;
  //   }
  // }

  onEditPopupHidden() {
    this.isEditPopupVisible = false;
    this.selectedArtikl = null;
  }

  onCreatePopupHidden() {
    this.isCreatePopupVisible = false;
  }
}
